<template>
  <div class="w-100">
    <b-form-group
      label-for="text"
      label="Введите имя клиента, номер или адрес"
    >
      <b-form-input
        for="text"
        v-model="clientName"
        class="w-100"
        @input="getClients"
      ></b-form-input>
    </b-form-group>
    <div class="w-100 mt-4">
      <b-alert
        :show="successShow"
        variant="success"
      >
        {{ responseText }}
      </b-alert>
      <b-table
        :fields="fields"
        :items="clients"
      >
        <template #cell(numbers)="{item}">
          <div
            class="mt-1"
            v-for="num in item.numbers"
            :key="num.id"
          >
            <span class="badge bg-primary font-size-12">{{num}}</span>
          </div>
        </template>
        <template #cell(action)="{item}">
          <b-button @click="getClientId(item)">
            <i class="bx bx-right-arrow"></i>
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
  import {searchClients} from "../../../../api/endpoints/clients";
  import {addClientLead} from "../../../../api/endpoints/lead";

  export default {
    name: "Clients",
    data() {
      return {
        clientName: '',
        searchTimeOut: null,
        fields: [{
            key: 'id',
            label: this.$t('table.id.label')
          },
          {
            key: "full_name",
            label: this.$t('table.full_name.label')
          },
          {
            key: 'driver.full_name',
            label: this.$t('table.driver.label')
          },
          {
            key: 'numbers',
            label: this.$t('table.numbers.label')
          },
          {
            key: 'address',
            label: this.$t('table.address.label')
          },
          {
            key: 'action',
            label: this.$t('table.actions.label')
          }
        ],
        clients: [],
        lead: {
          client_id: null,
        },
        successShow: false,
        responseText: "",
      }
    },
    methods: {
      getClients() {
        clearTimeout(this.searchTimeOut)
        this.searchTimeOut = setTimeout(() => {
          
          searchClients({
            search: this.clientName
          }).then(res => {
            this.clients = res.data.data;
          })
        }, 1000)
      },
      getClientId(item) {
        // eslint-disable-next-line no-console
        console.log(item);
        this.lead.client_id = item.id;
        addClientLead(this.lead).then(res => {
          var color;
          var statusTitle;
          let index = this.clients.findIndex(item => item.id === item.id);
          this.clients.splice(index, 1);
          if (res.data.message) {
            if (res.data.message !== 'already_added') {
              color = 'success';
              statusTitle = item.full_name;
              this.responseText = this.$t('canban.LeadAdded');
            } else {
              color = 'warning';
              statusTitle = item.full_name;
              this.responseText =  this.$t('canban.ClientAlreadyExists');
            }
          } else {
            color = 'success';
            statusTitle = item.full_name;
            this.responseText = this.$t('canban.LeadAdded');
            this.$emit('pushNewLead', res.data.data);
          }
          this.$vs.notification({
            icon: "<i class='bx bx-select-multiple' ></i>",
            color,
            position: "top-right",
            title: statusTitle,
            text: this.responseText,
          })
          this.$emit('pushNewLead', res.data.data);
        })
      }
    }
  }
</script>

<style scoped>

</style>
